import React, { useState } from 'react';
import FormFields from '../../../Forms/FormFields';
import './EnrollmentDetails.css';


type propsType = {
  formData: {
    [key: string]: any;
  };
  formState:any;
  handleFormChange:(value: string | boolean | any, key: string,  id: any)=>void;
};

const EnrollmentDetails = ({ formData,formState,handleFormChange }: propsType) => {
  
  return (
    <div className="create_enrollment_details_page">
      <form className="form_container_enrollment_details">
        <FormFields
          formData={formData}
          formState={formState}
          handleFormChange={handleFormChange}
        />
      </form>
    </div>
  );
};
export default EnrollmentDetails;
